let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dhY7N")).then(() => parcelRequire('Xu9Uw'));